/**
 * Pés Felizes: botão "Mostrar mais" das coleções.
 * A secção main-collection já ordena com stock primeiro e esgotados no fim.
 * Aqui vamos buscar a lista completa e ordenada (?view=pf-todos) e acrescentamos
 * os próximos N produtos de cada vez.
 */
const cache = new Map();

function fetchAllCards(url) {
  if (!cache.has(url)) {
    const request = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('[ref="grid"] > [data-pf-index]'));
      })
      .catch((error) => {
        cache.delete(url);
        throw error;
      });
    cache.set(url, request);
  }
  return cache.get(url);
}

function allCardsUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  url.searchParams.delete('section_id');
  url.searchParams.set('view', 'pf-todos');
  url.hash = '';
  return url.toString();
}

async function loadMore(button) {
  const grid = button.closest('results-list')?.querySelector('[ref="grid"]');
  if (!grid || button.classList.contains('btn--loading')) return;

  const perLoad = Number(button.dataset.pfPerLoad) || 24;
  const total = Number(button.dataset.pfTotal) || 0;
  const shown = grid.querySelectorAll(':scope > [data-pf-index]').length;

  button.classList.add('btn--loading');
  try {
    const cards = await fetchAllCards(allCardsUrl());
    const next = cards.slice(shown, shown + perLoad).map((card) => document.importNode(card, true));
    grid.append(...next);
    if (shown + next.length >= Math.min(total || cards.length, cards.length)) {
      button.closest('nav')?.remove();
    }
  } catch (error) {
    console.error('[pf-esgotados-fim]', error);
  } finally {
    button.classList.remove('btn--loading');
  }
}

// Pré-carrega a lista completa quando o botão se aproxima do ecrã, para o clique ser imediato.
const prefetchObserver = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      prefetchObserver.unobserve(entry.target);
      fetchAllCards(allCardsUrl()).catch(() => {});
    }
  },
  { rootMargin: '800px' }
);

function observeButtons() {
  document.querySelectorAll('[data-pf-load-more]:not([data-pf-observed])').forEach((button) => {
    button.setAttribute('data-pf-observed', '');
    prefetchObserver.observe(button);
  });
}

if (!window.pfEsgotadosFim) {
  window.pfEsgotadosFim = true;
  observeButtons();
  // Os filtros e a ordenação voltam a desenhar a secção: observar o botão novo.
  new MutationObserver(observeButtons).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pf-load-more]');
    if (!button) return;
    event.preventDefault();
    loadMore(button);
  });
}
